export default __webpack_public_path__ + "assets/images/2d91ca28219341efde4619add7c4dd77.svg";